export class NewsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NewsError';
  }
}
